import { EuiIcon } from "@elastic/eui";
import React from "react";

import DriverIcon from "../../../icons/DriverIcon";
import TruckIcon from "../../../icons/TruckIcon";

function EntityIcon({ entityName }) {
    switch (entityName) {
        case "trucks":
            return <TruckIcon />;

        case "drivers":
            return <DriverIcon />;

        case "locations":
            return <EuiIcon type="mapMarker" />;

        case "users":
        case "organization-assignees":
            return <EuiIcon type="user" />;

        case "orders":
            return <EuiIcon type="visTable" />;

        case "trips":
            return <EuiIcon type="list" />;

        case "projects":
            return <EuiIcon type="documents" />;

        case "suppliers":
            return <EuiIcon type="users" />;

        default:
            return "";
    }
}

export default EntityIcon;
